import { APIClient } from '@/infrastructure/network/Algolia/APIClient'

export class AlgoliaGatewayBase {
  apiClient: APIClient

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
  }
}
